import { onboardColors } from '../theme/onboardTokens';

// Portal palette — now a thin re-export surface over the centralized tokens.
// Kept as a local object so existing `palette.primary` call sites compile
// unchanged; each value resolves to the same hex as before via onboardColors.
export const palette = {
  bg: onboardColors.surface.page,
  card: onboardColors.surface.white,
  headingNeutral: onboardColors.neutral.textHeading,
  bodyNeutral: onboardColors.neutral.textBody,
  black: onboardColors.neutral.textStrong,
  divider: onboardColors.border.light,
  inputBorder: onboardColors.border.inputStrong,
  primary: onboardColors.brand.primary,
  primaryTint: onboardColors.brandTint.navy10,
  teal: onboardColors.brand.teal,
  tealDeep: onboardColors.brand.tealDeep,
  tealTint: onboardColors.brandTint.teal75,
  warning: '#A15957',
  green: onboardColors.status.successLight,
  pillNeutral: onboardColors.surface.uploadZone,
  uploadBg: '#F5F7F8',
  mediumRed: onboardColors.status.mediumRed
};

export const font = "'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
